export default __webpack_public_path__ + "static/media/Polymer_Logistics_6332.6efc16d6.jpg";